var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u7DE8\\u96C6\\u30E2\\u30FC\\u30C9",
    "data-name": "\\u7DE8\\u96C6\\u30E2\\u30FC\\u30C9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.68,8.5v96.38h68V8.5H22.68ZM82.21,93.57H31.12v-5.67h51.09v5.67ZM77.89,78c-2.35,0-4.25-1.9-4.25-4.25s1.9-4.25,4.25-4.25,4.25,1.9,4.25,4.25h0c0,2.35-1.9,4.25-4.25,4.25ZM82.14,59.36H31.14V17h51v42.36Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.37,
    y: 27.4,
    width: 42.52,
    height: 5.67,
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.37,
    y: 43.46,
    width: 42.52,
    height: 5.67,
    fill: "#040000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/StatsIcon.57c6825f6cb7727d0fbc50c075ed7bfb.svg";
export { ForwardRef as ReactComponent };